import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, CheckCircle } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Sarah M.',
    age: 34,
    location: 'Austin, TX',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200',
    quote: "I've struggled with facial puffiness for YEARS. After just 7 days with LymphoriaX, my face looked so much slimmer in the mirror. My jeans fit better, I have energy to play with my kids again, and I actually WANT to take photos now. This isn't just a supplement - it gave me my confidence back.",
    rating: 5,
    result: 'Lost 8 lbs water weight in 2 weeks',
    verified: true
  }, {
    name: 'Jennifer L.',
    age: 42,
    location: 'San Diego, CA',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200',
    quote: "I was SO skeptical. I've tried everything - compression socks, diuretics, you name it. But after 2 weeks with LymphoriaX, the puffiness in my ankles was GONE. I feel 10 pounds lighter, my skin is glowing, and my husband noticed the difference without me saying anything. I'm on my 4th bottle and never stopping.",
    rating: 5,
    result: 'Ankle swelling gone in 14 days',
    verified: true
  }, {
    name: 'Amanda K.',
    age: 38,
    location: 'Miami, FL',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80&w=200',
    quote: "This CHANGED EVERYTHING. No more 3pm crashes where I need coffee just to function. No more waking up bloated and puffy. I take it every morning and I genuinely look forward to it. My coworkers keep asking what I'm doing differently because my face looks so much more defined. Worth every single penny.",
    rating: 5,
    result: 'Face puffiness reduced 90%',
    verified: true
  }, {
    name: 'Rachel T.',
    age: 45,
    location: 'Portland, OR',
    image: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&q=80&w=200',
    quote: "Within 10 days I noticed my rings fit better and my face looked more defined in photos. The brain fog I've had for months just... lifted. I sleep better, I have more energy, and I feel like MYSELF again. I'm on my third bottle and I've already ordered 3 more. This is a game-changer.",
    rating: 5,
    result: 'Energy levels up 300%',
    verified: true
  }, {
    name: 'Lisa P.',
    age: 31,
    location: 'Chicago, IL',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&q=80&w=200',
    quote: "I've tried EVERYTHING for water retention - pills, teas, expensive spa treatments. LymphoriaX is the ONLY thing that actually worked. My legs don't feel heavy anymore, my stomach is flatter, and I have consistent energy all day. I feel like I finally found the solution I've been searching for.",
    rating: 5,
    result: 'Bloating eliminated completely',
    verified: true
  }, {
    name: 'Michelle R.',
    age: 39,
    location: 'Denver, CO',
    image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&q=80&w=200',
    quote: "After having my second baby, I couldn't get rid of the puffiness no matter what I tried. LymphoriaX helped me feel like myself again in just 3 weeks. My face is slimmer, my body feels lighter, and I finally have the energy to keep up with my toddlers. This is my secret weapon now.",
    rating: 5,
    result: 'Post-pregnancy puffiness gone',
    verified: true
  }];
  return <section className="py-24 bg-gradient-to-b from-white to-[#F0FFF4]" data-id="element-314">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-315">
        <div className="text-center mb-16" data-id="element-316">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-317">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-318">
              Real Results
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-4 mt-2" data-id="element-319">
              Trusted by 12,847+ Women
            </h2>
            <div className="flex justify-center items-center space-x-2 mb-2" data-id="element-320">
              <div className="flex text-[#10B981]" data-id="element-321">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-6 h-6 fill-current" data-id="element-322" />)}
              </div>
              <span className="font-bold text-[#1B5E20] text-xl" data-id="element-323">
                4.9/5 Average Rating
              </span>
            </div>
            <p className="text-[#374151]" data-id="element-324">Based on 12,847 verified reviews</p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-325">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl relative shadow-lg hover:shadow-xl transition-shadow border border-[#10B981]/10" data-id="element-326">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#10B981]/20" data-id="element-327" />

              {t.verified && <div className="absolute -top-3 left-6 bg-[#10B981] text-white px-3 py-1 rounded-full text-xs font-bold flex items-center space-x-1" data-id="element-328">
                  <CheckCircle className="w-3 h-3" data-id="element-329" />
                  <span data-id="element-330">Verified Purchase</span>
                </div>}

              <div className="flex items-center space-x-3 mb-4" data-id="element-331">
                <img src={t.image} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#10B981] shadow-md" data-id="element-332" />
                <div data-id="element-333">
                  <div className="font-bold text-[#1B5E20]" data-id="element-334">
                    {t.name}, {t.age}
                  </div>
                  <div className="text-xs text-[#374151]" data-id="element-335">{t.location}</div>
                  <div className="flex text-[#10B981] mt-1" data-id="element-336">
                    {[...Array(t.rating)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-337" />)}
                  </div>
                </div>
              </div>

              <p className="text-[#374151] leading-relaxed text-sm mb-4" data-id="element-338">
                "{t.quote}"
              </p>

              <div className="bg-[#10B981]/10 px-3 py-2 rounded-lg" data-id="element-339">
                <p className="text-xs font-bold text-[#1B5E20]" data-id="element-340">
                  ✨ {t.result}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Trust indicators */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-341">
          <div className="inline-flex items-center space-x-2 bg-white px-8 py-4 rounded-full shadow-lg border border-[#10B981]/20" data-id="element-342">
            <div className="flex text-[#10B981]" data-id="element-343">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-current" data-id="element-344" />)}
            </div>
            <span className="text-sm font-bold text-[#1B5E20]" data-id="element-345">
              Join 12,847+ women who transformed their lives
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}